
// @ts-nocheck
import Vue, {VueConstructor} from 'vue'
import FilterStateMixin from '~/mixins/filter-state.mixin'
import ResponsiveMixin from '~/mixins/responsive.mixin'

export default (Vue as VueConstructor<Vue & InstanceType<typeof FilterStateMixin> & InstanceType<typeof ResponsiveMixin>>).extend({
  name: 'ChefFilter',
  mixins: [FilterStateMixin, ResponsiveMixin],
  props: {
    chefId: {
      type: String,
      default: '',
      required: true
    },
    minGuests: {
      type: Number,
      required: true,
    },
    maxGuests: {
      type: Number,
      required: true,
    },
    blockedDates: {
      type: Array,
      required: false,
    }
  },
  async mounted() {
    this.$nuxt.$on('calculatePrice', () => {
      this.isAddressOpen = false
      this.isCalendarOpen = false
      this.isPersonOpen = false

      if (this.addressState === undefined) {
        this.isAddressOpen = true
        return;
      }

      if (this.calendarState === undefined) {
        this.isCalendarOpen = true
        return;
      }

      if (this.personState === 0) {
        this.isPersonOpen = true
        return;
      }
    })
  },
  beforeDestroy() {
    this.$nuxt.$off('calculatePrice')
  },
})
